(function () {
var badge = document.getElementById('cart-count');
var toast = document.getElementById('toast');
var toastText = document.getElementById('toast-text');
var toastTimer;
function say(msg) {
if (!toast || !toastText) return;
toastText.textContent = msg;
toast.classList.remove('opacity-0', 'translate-y-4');
clearTimeout(toastTimer);
toastTimer = setTimeout(function () { toast.classList.add('opacity-0', 'translate-y-4'); }, 2200);
}
function refreshCount() {
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (badge) badge.textContent = c.item_count; }).catch(function () {});
}
document.addEventListener('click', function (e) {
var a = e.target.closest ? e.target.closest('[data-add]') : null;
if (a) {
e.preventDefault();
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(a.getAttribute('data-add')), quantity: 1 }) })
.then(function (r) { if (!r.ok) throw 0; return r.json(); })
.then(function () { badge = document.getElementById('cart-count'); refreshCount(); say(a.getAttribute('data-name') + ' añadido al carrito'); })
.catch(function () { location.href = a.href; });
return;
}
var mega = document.getElementById('mega'), scrim = document.getElementById('mega-scrim'), megaBtn = document.getElementById('mega-btn'), chev = document.getElementById('mega-chev');
var drawer = document.getElementById('drawer');
if (e.target.closest('#mega-btn') && mega) { setMega(mega.hidden); return; }
if (e.target.closest('#mega-scrim')) { setMega(false); return; }
if (e.target.closest('[data-open-menu]') && drawer) { setDrawer(true); return; }
if (e.target.closest('[data-close-menu]')) { setDrawer(false); return; }
});
function setMega(open) {
var mega = document.getElementById('mega'), scrim = document.getElementById('mega-scrim'), btn = document.getElementById('mega-btn'), chev = document.getElementById('mega-chev');
if (!mega) return;
mega.hidden = !open; if (scrim) scrim.hidden = !open;
if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
if (chev) chev.style.transform = open ? 'rotate(180deg)' : '';
}
function setDrawer(open) {
var drawer = document.getElementById('drawer');
if (!drawer) return;
drawer.hidden = !open;
document.documentElement.style.overflow = open ? 'hidden' : '';
document.querySelectorAll('[data-open-menu]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
}
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMega(false); setDrawer(false); } });
window.matchMedia('(min-width: 768px)').addEventListener('change', function () { setDrawer(false); });
})();
